import { render, staticRenderFns } from "./MyContestLotterySetting.vue?vue&type=template&id=564bd631&scoped=true&"
import script from "./MyContestLotterySetting.js?vue&type=script&lang=js&"
export * from "./MyContestLotterySetting.js?vue&type=script&lang=js&"
import style0 from "./MyContestLotterySetting.scss?vue&type=style&index=0&id=564bd631&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bd631",
  null
  
)

export default component.exports